import {
  Box,
  ConnectionsBadgeIcon,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
  useTheme,
  WhiteTooltip
} from '@hermes/web-components'
import NextLink from 'next/link'
import { TEST_IDS } from '../../../../../../__tests__/testUtils/constants'
import { TopKeywordText } from './styles'
import useTranslateMessage from '../../../../../../hooks/useTranslateMessage'

export type ProfileTitleProps = {
  link: string
  profileFullName: string
  formattedSuffixes: string
  topLevelKeyword: string
  isUnclaimed: boolean
  isPractice: boolean
  specialistSuffix?: string
  feeAgreed?: boolean
  isPremium?: boolean
}

const ProfileTitle = ({
  link,
  profileFullName,
  formattedSuffixes,
  topLevelKeyword,
  isUnclaimed,
  feeAgreed,
  isPremium,
  specialistSuffix,
  isPractice
}: ProfileTitleProps) => {
  const theme = useTheme()
  const translate = useTranslateMessage()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <Grid container direction="column" gap="4px">
      <NextLink
        href={link}
        prefetch={false}
        onClick={(e) => e.preventDefault()}
        style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', minWidth: '100%', maxWidth: '80%' }}
      >
        <Grid container direction="row" alignItems="flex-end">
          <Typography
            fontWeight={700}
            fontSize="24px"
            lineHeight="32px"
            fontFamily="ES Klarheit Kurrent"
            color="text.darkNavy"
            data-testid={TEST_IDS.SEARCH_RESULT_CARD_FULL_NAME}
            component="h2"
            sx={{
              width: (feeAgreed || isPremium) && !isMobile ? 'calc(100% - 150px)' : '100%',
              wordBreak: 'break-word',
              minWidth: 'fit-content',
              maxWidth: 'fit-content'
            }}
          >
            <Box fontSize="24px" pr="24px" component="span">
              {profileFullName}
            </Box>
            <WhiteTooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    height: 'auto !important',
                    width: 'auto !important'
                  }
                }
              }}
              sx={{
                display: 'inline'
              }}
              title={isUnclaimed ? translate('profile.unverified') : translate('profile.verified')}
            >
              <Box ml="-20px" mr="4px" component="span" display="inline">
                <ConnectionsBadgeIcon
                  sx={{ width: '16px', height: '16px' }}
                  fill={isUnclaimed ? '#CC4F4A' : '#1A3586'}
                  innerStroke="#FFF"
                  withCross={isUnclaimed}
                />
              </Box>
            </WhiteTooltip>
          </Typography>
          <Hidden lgDown implementation="css">
            {!!specialistSuffix?.length && <TopKeywordText>{formattedSuffixes}</TopKeywordText>}
          </Hidden>
        </Grid>
      </NextLink>
      <Box
        display="flex"
        alignItems={{ xs: 'start', lg: 'center' }}
        flexDirection={{ xs: 'column', lg: 'row' }}
        data-testid={TEST_IDS.SEARCH_RESULT_CARD_KEYWORD}
      >
        {!isPractice && <TopKeywordText>{topLevelKeyword}</TopKeywordText>}
      </Box>
    </Grid>
  )
}

export default ProfileTitle
